var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeck = function SvgDeck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.45 9.895c1.409 0 2.55 1.137 2.55 2.543v33.07a2.546 2.546 0 0 1-2.55 2.545H10.445a2.547 2.547 0 0 1-2.55-2.545l-.001-5.32a2.543 2.543 0 0 1 2.55-2.543h6.94v-6.92a2.547 2.547 0 0 1 2.55-2.542h6.62v-6.602a2.546 2.546 0 0 1 2.552-2.542h6.62v-6.601a2.546 2.546 0 0 1 2.552-2.543ZM31.365 2.482a1.66 1.66 0 0 1 2.37.031c.645.673.631 1.75-.032 2.404C23.146 15.351 13.084 25.55 3.353 35.421v10.931c0 .938-.752 1.7-1.677 1.7-.926 0-1.676-.762-1.676-1.7V34.717c0-.45.176-.883.491-1.203 9.893-10.032 20.122-20.408 30.875-31.032Z"
  })));
};

export default SvgDeck;